import React, { FC } from 'react';
import './task-detail-grid.scss';

interface RequestPageProps {
  label: string;
  children?: React.ReactNode;
  testId?: string;
}

const TaskDetailGrid: FC<RequestPageProps> = ({ label, children = '', testId = '' }) => {
  return (
    <>
      <div className="label">{label}</div>
      <div className="value" {...(testId ? { 'data-testid': testId } : '')}>
        {children}
      </div>
    </>
  );
};

export default TaskDetailGrid;
